import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthProvider";
import LoadingPage from "../components/LoadingPage";
import NotFoundPage from "../components/NotFoundPage";

const PrivateRoute = ({ permission, notPermission }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return <LoadingPage />;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (permission && !user.permissions?.some((p) => p.permission_name === permission && p.can_view === 1)) {
    return <NotFoundPage />;
  }

  if (notPermission && user.permissions?.some((p) => p.permission_name === notPermission && p.can_view === 1)) {
    return <NotFoundPage />;
  }

  return <Outlet />;
};

export default PrivateRoute;
